import { ChevronRight } from "lucide-react";

import { Button } from "@/components/button";

import type { ReviewCtaData } from "../../types/mbc-chat.types";

type ReviewBriefCTAProps = {
  cta: ReviewCtaData;
  isDisabled: boolean;
  onReview: () => void;
};

export function ReviewBriefCTA({
  cta,
  isDisabled,
  onReview,
}: ReviewBriefCTAProps) {
  return (
    <Button
      className="mt-md gap-sm"
      isDisabled={isDisabled}
      onPress={onReview}
      variant="primary"
    >
      {cta.label}
      <ChevronRight className="size-4" />
    </Button>
  );
}
